import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import analyticsMetricsDetailsUpsellIllustration from '../../../assets/images/analyticsMetricsDetailsUpsellIllustration.svg';
import {ContactSalesButton} from '../../../components/common/callToAction/contactSalesButton';
import {LearnMoreButton} from '../../../components/common/callToAction/learnMoreButton';
import {Pill} from '../../../components/pill/pill';
import {helpCenterUrl} from '../../../store/stateless/navigationActions';

/*
 * Styles.
 */

const SidePanelOverlayWrapper = styled.div`
  position: absolute;
  height: 500px;
  bottom: 0;
  left: 1px;
  right: 0;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 20%,
    rgba(255, 255, 255, 1) 100%
  );

  display: flex;
  padding: 16px;
  padding-top: 100px;
`;

const SidePanelOverlayUpsellCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: 100%;
`;

const SidePanelOverlayUpsellCardTitle = styled.div`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  margin-top: 10px;
  margin-bottom: 5px;
`;

const SidePanelOverlayUpsellCardBody = styled.div`
  font-size: ${fontSizes.medium};
  color: ${(p) => p.theme.greys.shade50};
`;

const SidePanelOverlayButtons = styled.div`
  margin-top: 18px;
  display: flex;

  > *:not(:first-child) {
    margin-left: 10px;
  }
`;

const SidePanelOverlayIllustration = styled.div`
  width: 100%;
  height: 80px;

  margin-top: 14px;
  margin-right: -10px;

  background-size: contain;
  background-position: right;
  background-image: url(${analyticsMetricsDetailsUpsellIllustration});
`;

const StyledPillWrapper = styled.div`
  width: fit-content;
`;

/*
 * Component.
 */

export const ReportSidePanelUpsellOverlay: FC = () => (
  <SidePanelOverlayWrapper>
    <SidePanelOverlayUpsellCard>
      <StyledPillWrapper>
        <Pill size={VisualSizesEnum.MEDIUM}>
          <Trans id="analytics-upsell-available-with-prime">AVAILABLE WITH PRIME</Trans>
        </Pill>
      </StyledPillWrapper>
      <SidePanelOverlayUpsellCardTitle>
        <Trans id="analytics-metrics-details-upsell-title">
          Understand the story
          <br />
          behind your metrics
        </Trans>
      </SidePanelOverlayUpsellCardTitle>
      <SidePanelOverlayUpsellCardBody>
        <Trans id="analytics-metrics-details-upsell-body">
          With metric details, you can review conversations contributing to metric values. Diagnose outliers,
          coach your team, export data, and more.
        </Trans>
      </SidePanelOverlayUpsellCardBody>
      <SidePanelOverlayButtons>
        <ContactSalesButton />
        <LearnMoreButton helpPageUrl={`${helpCenterUrl}/t/83hz4ty/analytics-metric-details`} />
      </SidePanelOverlayButtons>
      <SidePanelOverlayIllustration />
    </SidePanelOverlayUpsellCard>
  </SidePanelOverlayWrapper>
);
